import React from "react";

// ---------------------------------------------------------------------------
// What your organisation leaves with
// Four outcome cards addressed to specific reader groups. Sits below Journey
// Storybooks and before the "Choose your next step" CTA block. Public,
// generic, no private opportunity content.
// ---------------------------------------------------------------------------

const OUTCOMES = [
  {
    id: "business-development",
    label: "Business development",
    body:
      "A repeatable proposition, partner route and sector-ready commercial story.",
  },
  {
    id: "technology-and-ai",
    label: "Technology and AI",
    body:
      "A practical integration model for AI tools, agents, legacy systems, workflows and evidence boundaries.",
  },
  {
    id: "ceo-cto-compliance",
    label: "CEO, CTO and compliance",
    body:
      "Clear authority, accountability, assurance and receipt-backed oversight.",
  },
  {
    id: "research-and-partners",
    label: "Research and partners",
    body:
      "A governed place to introduce models, expertise, evaluation, assurance and sector innovation.",
  },
];

export const WhatYouLeaveWith = () => {
  return (
    <section
      id="what-you-leave-with"
      data-testid="section-what-you-leave-with"
      className="relative py-20 lg:py-24 border-t border-white/[0.06] bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-10">
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
            Outcomes
          </div>
          <h2
            data-testid="leave-with-headline"
            className="font-display text-3xl sm:text-4xl lg:text-[44px] mt-4 leading-[1.08]"
          >
            What your organisation{" "}
            <span className="text-slate-400">leaves with.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06] border border-white/[0.06]">
          {OUTCOMES.map((o, i) => (
            <article
              key={o.id}
              data-testid={`leave-with-${o.id}`}
              className="bg-[#040F1B] p-6 lg:p-7 flex flex-col"
            >
              <div className="flex items-baseline gap-3">
                <span className="mono text-[10px] uppercase tracking-[0.22em] text-[#0066FF]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="h-px flex-1 bg-white/10" />
              </div>
              <h3 className="mt-4 font-display text-[16px] sm:text-[17px] text-white leading-snug">
                {o.label}
              </h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">
                {o.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
